import {  SET_WEB5 } from './actionTypes';

export const setWeb5 = (web5) => ({
  type: SET_WEB5,
  payload: web5,
});
